import { render, staticRenderFns } from "./DeleteAlertModal.vue?vue&type=template&id=f3b284a8&scoped=true&"
import script from "./DeleteAlertModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAlertModal.vue?vue&type=style&index=0&id=f3b284a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b284a8",
  null
  
)

export default component.exports